import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '~/utils/cnTailwind';

type Props = {
    children: React.ReactNode;
    className?: string;
    title?: string;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className' | 'children' | 'title'>;

export const FormCard: React.FC<Props> = ({ children, className, title, ...rest }) => {
    return (
        <div className={cn('flex flex-col gap-2 rounded bg-white px-5 py-2.5', className)} {...rest}>
            {title && <p className="text-sm font-bold text-midnight">{title}</p>}
            {children}
        </div>
    );
};
